"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getZIndexFromRow = exports.getOverflowTextStyles = void 0;
require("./overflow.css");
var _zIndex = require("@cbhq/cds-common/tokens/zIndex");
const getZIndexFromRow = (row, totalRows) => totalRows - row + _zIndex.zIndex.interactable;
exports.getZIndexFromRow = getZIndexFromRow;
const truncatedStyles = "cds-truncatedStyles-tldl3hj";
const overflowStyles = "cds-overflowStyles-o16piyup";
const getOverflowTextStyles = expanded => expanded ? overflowStyles : truncatedStyles;
exports.getOverflowTextStyles = getOverflowTextStyles;